import { FormattedMessage } from 'react-intl';

import { Business, CallOutlined } from '@mui/icons-material';
import {
  FileTextOutlined,
  NotificationOutlined,
  PlayCircleOutlined,
  BuildOutlined,
  TranslationOutlined,
  AppstoreAddOutlined,
  RobotOutlined,
  AuditOutlined,
  BellOutlined,
  SettingOutlined,
  ControlOutlined,
  TagOutlined,
  TeamOutlined,
  PhoneOutlined,
  ApiOutlined,
  OpenAIOutlined,
  ThunderboltOutlined,
  CloudSyncOutlined,
  GlobalOutlined,
  ReadOutlined,
  MessageOutlined,
  BarChartOutlined,
  SafetyCertificateOutlined,
  DashboardOutlined,
} from '@ant-design/icons';

const icons = {
  dashboard: DashboardOutlined,
  BusinessIcon: Business,
  did: BuildOutlined,
  inboundDid: PhoneOutlined,
  sipTrunks: ApiOutlined,
  template: FileTextOutlined,
  voice: NotificationOutlined,
  action: PlayCircleOutlined,
  language: TranslationOutlined,
  callType: CallOutlined,
  feature: AppstoreAddOutlined,
  audit: AuditOutlined,
  platformAlerts: BellOutlined,
  settings: SettingOutlined,
  systemDefaults: ControlOutlined,
  promo: TagOutlined,
  users: TeamOutlined,
  permissions: SafetyCertificateOutlined,
  llm: OpenAIOutlined,
  defaults: CloudSyncOutlined,
  domains: GlobalOutlined,
  agentTemplate: RobotOutlined,
  prompts: MessageOutlined,
  workspaceAssistant: ThunderboltOutlined,
  pcm: BarChartOutlined,
  blog: ReadOutlined
};

const modules = {
  id: 'group-modules',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: <FormattedMessage id="dashboard" defaultMessage="Dashboard" />,
      type: 'item',
      icon: icons.dashboard,
      url: '/dashboard'
    },
    {
      id: 'customer',
      title: <FormattedMessage id="tenants" defaultMessage="Tenants" />,
      type: 'item',
      icon: icons.BusinessIcon,
      url: '/customer'
    },
    {
      id: 'usersWorkspaces',
      title: <FormattedMessage id="user-access" defaultMessage="User Access" />,
      type: 'item',
      icon: icons.users,
      url: '/users-workspaces'
    },
    {
      id: 'permissions',
      title: <FormattedMessage id="role-permissions" defaultMessage="Role Permissions" />,
      type: 'item',
      icon: icons.permissions,
      url: '/permissions'
    },
    {
      id: 'telephony',
      title: <FormattedMessage id="telephony" defaultMessage="Telephony" />,
      type: 'collapse',
      icon: icons.did,
      children: [
        { id: 'dids', title: <FormattedMessage id="dids" defaultMessage="DID Inventory" />, type: 'item', url: '/didManagement/public' },
        {
          id: 'inboundDids',
          title: <FormattedMessage id="inbound-dids" defaultMessage="Inbound DIDs" />,
          type: 'item',
          url: '/inbound-dids'
        },
        { id: 'sipTrunks', title: <FormattedMessage id="sip-trunks" defaultMessage="SIP Trunks" />, type: 'item', url: '/sip-trunks' }
      ]
    },
    {
      id: 'domains',
      title: <FormattedMessage id="domains" defaultMessage="Domains" />,
      type: 'item',
      icon: icons.domains,
      url: '/domains'
    },
    {
      id: 'vendorModels',
      title: <FormattedMessage id="vendor-models" defaultMessage="Vendor Models" />,
      type: 'item',
      icon: icons.llm,
      url: '/vendorModels'
    },
    {
      id: 'agentTemplates',
      title: <FormattedMessage id="agent-templates" defaultMessage="Agent Templates" />,
      type: 'item',
      icon: icons.agentTemplate,
      url: '/agent-templates'
    },
    {
      id: 'prompts',
      title: <FormattedMessage id="prompts" defaultMessage="Generate Prompts" />,
      type: 'item',
      icon: icons.prompts,
      url: '/prompts'
    },
    {
      id: 'workspaceAssistant',
      title: <FormattedMessage id="workspace-assistant" defaultMessage="Workspace Assistant" />,
      type: 'item',
      icon: icons.workspaceAssistant,
      url: '/workspace-assistant'
    },
    {
      id: 'pcm',
      title: <FormattedMessage id="pcm" defaultMessage="PCM" />,
      type: 'item',
      icon: icons.pcm,
      url: '/pcm'
    },
    {
      id: 'reference',
      title: <FormattedMessage id="reference" defaultMessage="Reference Data" />,
      type: 'collapse',
      icon: icons.template,
      children: [
        { id: 'template', title: <FormattedMessage id="template" defaultMessage="Templates" />, type: 'item', url: '/template/public' },
        { id: 'voice', title: <FormattedMessage id="voice" defaultMessage="Voices" />, type: 'item', url: '/voice/public' },
        { id: 'action', title: <FormattedMessage id="action" defaultMessage="Actions" />, type: 'item', url: '/action/public' },
        { id: 'language', title: <FormattedMessage id="language" defaultMessage="Languages" />, type: 'item', url: '/language/public' },
        { id: 'callType', title: <FormattedMessage id="call-type" defaultMessage="Call Types" />, type: 'item', url: '/callType/public' },
        {
          id: 'referenceChannels',
          title: <FormattedMessage id="reference-channels" defaultMessage="Channels" />,
          type: 'item',
          url: '/reference/channels'
        },
        {
          id: 'whatsappTemplates',
          title: <FormattedMessage id="whatsapp-templates" defaultMessage="WhatsApp Templates" />,
          type: 'item',
          url: '/reference/whatsapp-templates'
        },
        {
          id: 'instagramTemplates',
          title: <FormattedMessage id="instagram-templates" defaultMessage="Instagram Templates" />,
          type: 'item',
          url: '/reference/instagram-templates'
        }
      ]
    },
    {
      id: 'featureFlags',
      title: <FormattedMessage id="feature-flags" defaultMessage="Feature Flags" />,
      type: 'item',
      icon: icons.feature,
      url: '/feature-flags'
    },
    {
      id: 'promocodes',
      title: <FormattedMessage id="promocodes" defaultMessage="Promo Codes" />,
      type: 'item',
      icon: icons.promo,
      url: '/promocodes'
    },
    {
      id: 'blog',
      title: <FormattedMessage id="blog" defaultMessage="Blog" />,
      type: 'item',
      icon: icons.blog,
      url: '/blog'
    },
    {
      id: 'systemDefaults',
      title: <FormattedMessage id="system-default" defaultMessage="System Default" />,
      type: 'item',
      icon: icons.systemDefaults,
      url: '/system-defaults'
    },
    {
      id: 'settings',
      title: <FormattedMessage id="settings" defaultMessage="Settings" />,
      type: 'item',
      icon: icons.settings,
      url: '/settings'
    },
    {
      id: 'audit',
      title: <FormattedMessage id="audit-log" defaultMessage="Audit Log" />,
      type: 'item',
      icon: icons.audit,
      url: '/audit-log'
    },
    {
      id: 'platform-alerts',
      title: <FormattedMessage id="platform-alerts" defaultMessage="Platform Alerts" />,
      type: 'item',
      icon: icons.platformAlerts,
      url: '/platform-alerts'
    },
    {
      id: 'platformDefaults',
      title: <FormattedMessage id="platform-defaults" defaultMessage="Platform Defaults" />,
      type: 'item',
      icon: icons.defaults,
      url: '/platform-defaults'
    }
  ]
};

export default modules;
